module.exports = __webpack_public_path__ + "media/banner_bg.b3568ee0.mp4";